import { format, lastDayOfMonth, startOfMonth, addDays, startOfDay } from 'date-fns';
import { Query } from '../types/v2/holiday-search';
import { formatHolidayDateSelection } from './formatter';

export const getDatesInRange = (startDate: Date, endDate: Date, dateFormat?: string) => {
  const currentDate = new Date(startDate);
  const daysInRange = [];

  while (currentDate <= endDate) {
    daysInRange.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return daysInRange.map((date) => (!dateFormat ? date : format(date, dateFormat)));
};

export const getAllDaysInMonth = (month: string) => {
  const currentDate = startOfDay(new Date());
  const startDate =
    currentDate > startOfMonth(new Date(month)) ? currentDate : startOfMonth(new Date(month));
  const endDate = lastDayOfMonth(new Date(month));

  if (currentDate > startDate) {
    startDate.setDate(currentDate.getDate());
  }

  return getDatesInRange(startDate, endDate, 'yyyy-MM-dd');
};

export const getAllDatesFromMultipleMonths = (months: string[]) =>
  months
    .map((month) => getAllDaysInMonth(month))
    .flat()
    .sort();

export const dropDownMonthFormatter = (months: string): string | undefined => {
  try {
    const monthsArray = months?.split(',');
    const monthOnly = monthsArray?.map((month: string) => month.split('-')[1]);
    const monthFilter =
      monthOnly?.filter((item: string, index: number) => {
        return monthOnly?.indexOf(item) !== index;
      }) || [];
    if (monthFilter?.length > 0) {
      return monthsArray
        ?.map((month: string) => `${format(new Date(month), 'MMMM')} (${month.split('-')[0]})`)
        .join(', ');
    }
    return monthsArray?.map((month: string) => format(new Date(month), 'MMMM')).join(', ');
  } catch (err) {
    return undefined;
  }
};

export const rangeDateFormatter = (date: string, twoDigitYearFormat?: boolean) => {
  if (twoDigitYearFormat) return format(new Date(date), 'd MMMM yy');
  return format(new Date(date), 'd MMMM yyyy');
};

export const getFilterWhenSelection = (
  query: Query,
  skipDateRange = false,
  twoDigitYearFormat = false,
) => {
  if (query.startDate && !skipDateRange) {
    return `${rangeDateFormatter(query.startDate, twoDigitYearFormat)} - ${
      query.endDate ? rangeDateFormatter(query.endDate, twoDigitYearFormat) : 'select end date'
    }`;
  }
  if (query.month) {
    return dropDownMonthFormatter(query.month);
  }
  if (query.duration?.includes(',') || query.arrivalDate?.includes(',')) {
    return 'Selected dates';
  }
  if (!query.duration || !query.arrivalDate || !Number.isInteger(Number(query.duration))) {
    return 'Please select a date';
  }
  if (query.arrivalDate.length > 0 && !query.arrivalDate?.includes(',')) {
    const dates = {
      arrivalDate: new Date(query.arrivalDate),
      checkoutDate: addDays(new Date(query.arrivalDate), Number(query.duration)),
      numOfNights: Number(query.duration),
    };
    return formatHolidayDateSelection(dates, false, false, twoDigitYearFormat);
  }
  return '';
};
